import React, { Component } from 'react';

class TabList extends Component {
    constructor(props) {
        super(props);
    }
    updateStoreList = (e)=>{
        const tabIndex = e.currentTarget.getAttribute("data-index");
        this.props.updateStoreList(tabIndex);
    };
    render() {
        const {tabs,activeIndex} = this.props;
        return (
            <ul className="placeholder tabs-left">
                {
                    tabs.map((tab,index) => {
                        return <li key={ index.toString() } className="tabs-left-item" data-index={index} onChange={this.updateStoreList} onClick={this.updateStoreList} style={{background:activeIndex == index ? '#fff': 'none'}}>{ tab.title }</li>;
                    })
                }
            </ul>
        );

    }
}

export default TabList;